import { useRoute } from 'vue-router'
import { useApi } from '~/composables/common/use-api'
import { ResponseStatus } from '~composables/common/interface'
import { AUTH_API } from '~/configs/api'
import { useError } from '~/composables/common/use-error'
import { modalList } from '~resources/popup-notification.ts'
import { notificationPopup } from '~utils/modal/notify.ts'
import { useLogout } from '~/composables/account/use-logout'
import { toastPopup } from '~/utils/modal/toast'

interface IPasswordReset {
  newPassword: string
  confirmPassword: string
}
interface ForgotPassword {
  email: string
}
export function useResetPassword() {
  const { request } = useApi()
  const { showError } = useError()
  const { submitLogout } = useLogout()
  const route = useRoute()
  const messageError = ref('')
  const email = ref('')
  const passwordReset = reactive<IPasswordReset>({
    newPassword: '',
    confirmPassword: ''
  })
  const isDisableFormReset = computed(() => !passwordReset.newPassword || !passwordReset.confirmPassword)
  const forgotPassword = reactive<ForgotPassword>({
    email: ''
  })
  const isDisableFormForgot = computed(() => forgotPassword.email)

  function resetError(): void {
    messageError.value = ''
  }

  function clearInput(): void {
    messageError.value = ''
  }
  async function handleSubmitForgotPassword(): Promise<void> {
    messageError.value = ''
    try {
      const response = await request(AUTH_API.FORGOT_PASSWORD, {
        method: 'POST',
        body: {
          email: email.value
        }
      })
      if (response?.status === ResponseStatus.OK) {
        const emailSuccessNotification = { ...modalList.EMAIL_SUCCESS }
        emailSuccessNotification.description = emailSuccessNotification.description.replace('[EMAIL]', email.value)
        notificationPopup(emailSuccessNotification)
      } else {
        messageError.value = 'Đã xảy ra lỗi. Vui lòng kiểm tra lại!'
        if (response?.message) {
          messageError.value = response.message
        }
      }
    } catch {
      messageError.value = 'Đã xảy ra lỗi. Vui lòng kiểm tra lại!'
    }
    // Show error
    if (messageError.value) {
      showError(messageError.value)
    }
  }
  async function handleSubmitResetPassword(): Promise<void> {
    messageError.value = ''
    const token = route.query?.token
    try {
      const response = await request(AUTH_API.UPDATE_RESET_PASSWORD, {
        method: 'PUT',
        headers: {
          token
        },
        body: {
          password: passwordReset.newPassword
        }
      })
      if (response?.status === ResponseStatus.OK) {
        sessionStorage.setItem('changePassword', 'success')
        toastPopup({ title: 'Cập nhập thông tin thành công', type: 'success' })
        await submitLogout()
      } else {
        messageError.value = 'Đã xảy ra lỗi. Vui lòng kiểm tra lại!'
        if (response?.status === ResponseStatus.AUTHENTICATION_REQUIRED_ERROR) {
          messageError.value = 'Link đổi mật khẩu không hợp lệ.'
        } else if (response?.message) {
          messageError.value = response.message
        }
        notificationPopup(modalList.CHANGE_PASS_ERROR)
      }
    } catch {
      toastPopup({ title: 'Lỗi mạng, vui lòng thử lại', type: 'error' })
      messageError.value = 'Đã xảy ra lỗi. Vui lòng kiểm tra lại!'
    }
    // Show error
    if (messageError.value) {
      showError(messageError.value)
    }
  }
  return {
    email,
    messageError,
    passwordReset,
    isDisableFormReset,
    isDisableFormForgot,
    handleSubmitForgotPassword,
    handleSubmitResetPassword,
    resetError,
    clearInput
  }
}
